import { Container, Row } from 'react-bootstrap';
import BarChart from '../../../../components/BarChart';
import Link from '../../../../components/Link';
import Select from '../../../../components/Select';
import useModal from '../../../../hooks/useModal';
import FormsOfPaymentModal from '../../FormsOfPaymentModal/FormsOfPaymentModal';

export type customPaymentConfirmationProps = {
  dataCharts: any;
  prices?: { termination: number; beneficiary: number };
  ageOfPension: number;
  visibleFormsOfPayment?: boolean;
  formsOfPaymentTableData?: any;
  selectedPaymentOption?: string;
  paymentOptions: any[];
  handlePaymentOptionChange?: (e: any) => void;
  isInline: boolean;
  handleBackToResults?: any;
  handleFormsOfPayment?: any;
};

const PaymentConfirmation = ({
  dataCharts,
  prices,
  isInline,
  handleBackToResults,
  handleFormsOfPayment,
  ageOfPension,
  visibleFormsOfPayment = false,
  formsOfPaymentTableData,
  paymentOptions,
  handlePaymentOptionChange,
  selectedPaymentOption,
}: customPaymentConfirmationProps) => {
  const [
    showFormsOfPaymentModal,
    handleShowFormsOfPaymentModal,
    handleCloseFormsOfPaymentModal,
  ] = useModal();

  return (
    <Container className="p-0 mt-10">
      <section>
        <Row className="m-0">
          <BarChart
            data={dataCharts.chart1}
            total={prices?.termination || 0}
            showLegend={false}
            label={`Termination at age ${ageOfPension} and Payments begin at age ${ageOfPension}`}
          />
        </Row>
        <Row className="m-0 mt-10">
          <BarChart
            data={dataCharts.chart2}
            total={prices?.beneficiary || 0}
            showLegend={true}
            label={'Beneficiary payments upon your death'}
          />
        </Row>
      </section>
      <section className="mt-10" style={{ maxWidth: 255 }}>
        <div>
          <Select
            label="Form of Payment"
            options={paymentOptions}
            defaultOption={paymentOptions.find((e) => {
              if (selectedPaymentOption) {
                return e.value === selectedPaymentOption;
              }
              return e.value === '1';
            })}
            onChange={handlePaymentOptionChange}
          />
        </div>
        {visibleFormsOfPayment && (
          <div className="text-caption text-indigo fw-light pt-3">
            <Link
              isBlue
              className={'py-0'}
              onClick={
                isInline ? handleFormsOfPayment : handleShowFormsOfPaymentModal
              }
            >
              <span className={'text-caption fw-light'}>
                All forms of payment
              </span>
            </Link>
            <FormsOfPaymentModal
              showFormsOfPaymentModal={showFormsOfPaymentModal}
              handleCloseFormsOfPaymentModal={handleCloseFormsOfPaymentModal}
              modalData={formsOfPaymentTableData}
            />
          </div>
        )}
      </section>
    </Container>
  );
};

export default PaymentConfirmation;
